module.exports = __webpack_public_path__ + "img/dots-default-profile.ef971022.svg";